import NavBar from "./NavBar";
import { Box, CssBaseline, AppBar, Toolbar, Typography } from "@mui/material";

function Layout({ variant = "default", color, title, subtitle, onAdminToggle, map = false, children, extra, searchBar, backBtnNavigateHome = false, isAdminView }) {
    if (variant === "appbar") {
        return (
            <>
                <CssBaseline />
                <AppBar position="sticky" sx={{ backgroundColor: color }}>
                    <Toolbar sx={{ paddingTop: "1rem", paddingBottom: "1rem" }}>
                        <Typography variant="h5" noWrap sx={{ flexGrow: 1 }}>
                            {title}
                        </Typography>
                        {searchBar}
                    </Toolbar>
                </AppBar>
                <Box component="main" sx={{ flexGrow: 1, p: 3, overflowX: "hidden" }}>
                    {children}
                </Box>
            </>
        );
    }
    return (
        <>
            <CssBaseline />
            <NavBar
                color={color}
                title={title}
                subtitle={subtitle}
                onAdminToggle={onAdminToggle}
                map={map}
                extra={extra}
                backBtnNavigateHome={backBtnNavigateHome}
                isAdminView={isAdminView}
            />
            <Box
                sx={{
                    minHeight: "100vh",
                    padding: "0px",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Box component="main" sx={{ flexGrow: 1, p: 3, overflowX: "hidden" }}>
                    {children}
                </Box>
            </Box>
        </>
    );
}

export default Layout;
